import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")

import { ref, computed, reactive, onMounted, nextTick } from 'vue'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { getNumber,formatNumber} from '@/utils/index'
import Api from '@/http/modules/index'
import * as echarts from "echarts";
import { number } from 'mathjs'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
    'POST/translator_report/costing':tranlastorCostingApi,
    'GET/organizations':organizationsApi
} = Api
const store = useStore()
const tableHeight=window.innerHeight-160
const tranlastorCostingList=ref([])
const defaultMonthRange=[dayjs(new Date().setMonth(new Date().getMonth()-1)).startOf("month").format("YYYY-MM-DD"),dayjs(new Date().setMonth(new Date().getMonth()-1)).startOf("month").format("YYYY-MM-DD")]
const queryForm=reactive({
    month:defaultMonthRange,
    orgId:""
})
const organizations=ref([])
const tableLoading=ref(false)
const averageEfficiency=ref<any>("")
const monthAverageEfficiency=ref<any>("")
const getTranlastorCostingList=(isReset:boolean=false)=>{
    if(isReset){
        queryForm.month=defaultMonthRange
        queryForm.orgId=""
    }
    let {month,orgId}=queryForm
    if(dayjs(month[1]).diff(dayjs(month[0]).format("YYYY-MM-DD"), 'months', true)>23){
        ElMessage.warning("所选日期范围不能超过24个月")
        return
    }
    let params={
        monthFrom:dayjs(month[0]).format("YYYY-MM-DD"),
        monthTo:dayjs(month[1]).format("YYYY-MM-DD"),
        userIds:[],
        orgId
    }
    tableLoading.value=true
    tranlastorCostingApi(params).then(((res:any)=>{
        tranlastorCostingList.value=res.data
        averageEfficiency.value=res.averageEfficiency
        tableLoading.value=false
    })).catch(()=>{
        tableLoading.value=false
    })
}
const detailData=reactive<any>({
    orderList:[],
    salaryList:[]
})
const showType=reactive({
    order:false,
    salary:false
})
const currentUser=ref<any>({})
const showDetail=(key:string,row:any)=>{
    detailData[key]=row[key]
    monthAverageEfficiency.value=row.averageEfficiency
    if(key=='orderList'){
        showType.order=row.userId==currentUser.value.userId?!showType.order:true
        showType.salary=false
    }else{
        showType.salary=row.userId==currentUser.value.userId?!showType.salary:true
        showType.order=false 
    }
    currentUser.value={
        name:`${row.alias}（${row.realName}）`,
        userId:row.userId
    }
    
}
const formatEff=(row:any)=>{
    return row.efficiency.toFixed(2)+'%'
}
const getSummaries=(param:any)=>{
   const { columns, data } = param;
      let sums:any = [];
      columns.forEach((column:any, index:any) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        } else if (column.property != "name"&&column.property !="month"&&column.property!='efficiency') {            
          //如果是经费（正常的加减法）
          const values = data.map((item:any) => Number(item[column.property]));
          if (!values.every((value:any) => isNaN(value))) {
            sums[index] = values.reduce((prev:any, curr:any) => {
              const value = Number(curr);
              var sum:any= 0;
              if (!isNaN(value)) {
                sum = Number(Number(prev) + Number(curr)).toFixed(2);
                return sum;
              } else {
                return prev;                            
              }
            }, 0);
            sums[index] += " ";

          }
        }else if(column.property=='efficiency'){
            if(column.label=='生产效率'){
                sums[index]=averageEfficiency.value+'%'
            }else{
                sums[index]=monthAverageEfficiency.value+'%'
            }     
        }
      });
      let res:any=sums.map((el:any)=>{
        return Number(el)?getNumber(el):el
      })
      return res;
}
onMounted(()=>{
    getTranlastorCostingList()
    organizationsApi().then((res:any)=>{
        organizations.value=res
    })
})

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, {
          title: "搜索",
          name: "1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              class: "searchContent searchBg",
              model: _unref(queryForm),
              style: {"padding-top":"26px"},
              "label-width": "90px",
              inline: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "日期:",
                  prop: "date"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(queryForm).month,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(queryForm).month) = $event)),
                      type: "monthrange",
                      "range-separator": "至"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "团队:",
                  prop: "orgId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(queryForm).orgId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(queryForm).orgId) = $event)),
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            value: item.id,
                            label: item.name
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (getTranlastorCostingList()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (getTranlastorCostingList(true)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 24 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              "max-height": tableHeight+'px',
              "summary-method": getSummaries,
              "show-summary": "",
              border: "",
              data: tranlastorCostingList.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "译员（点击）",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withCtx(({row}) => [
                    _createVNode(_component_el_link, {
                      class: "no-selection",
                      underline: false,
                      onClick: ($event: any) => (showDetail('orderList',row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(`${row.alias}（${row.realName}）`), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "orgName",
                  label: "团队"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "sumOrder",
                  label: "累计订单额",
                  sortable: "",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  prop: "sumOrderBasicCurrency",
                  label: "本位币",
                  sortable: "",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  prop: "sumSalary",
                  label: "累计薪酬（点击）",
                  width: "180",
                  sortable: "",
                  align: "right"
                }, {
                  default: _withCtx(({row}) => [
                    _createVNode(_component_el_link, {
                      class: "no-selection",
                      underline: false,
                      onClick: ($event: any) => (showDetail('salaryList',row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getNumber)(row.sumSalary)), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "efficiency",
                  label: "生产效率",
                  sortable: "",
                  align: "right",
                  formatter: formatEff
                })
              ]),
              _: 1
            }, 8, ["max-height", "data"])), [
              [_directive_loading, tableLoading.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            (_unref(showType).order)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_tag, null, {
                    default: _withCtx(() => [
                      _createTextVNode("当前查看：" + _toDisplayString(currentUser.value.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table, {
                    "max-height": tableHeight+'px',
                    "summary-method": getSummaries,
                    "show-summary": "",
                    border: "",
                    data: _unref(detailData).orderList
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "month",
                        label: "月度"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "amount",
                        label: "订单金额",
                        align: "right",
                        formatter: _unref(formatNumber)
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        prop: "basicCurrency",
                        label: "本位币",
                        align: "right",
                        formatter: _unref(formatNumber)
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        prop: "salaryAmount",
                        label: "薪酬",
                        align: "right",
                        formatter: _unref(formatNumber)
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        prop: "efficiency",
                        label: "月度生产效率",
                        align: "right",
                        formatter: formatEff
                      })
                    ]),
                    _: 1
                  }, 8, ["max-height", "data"])
                ], 64))
              : _createCommentVNode("", true),
            (_unref(showType).salary)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_tag, null, {
                    default: _withCtx(() => [
                      _createTextVNode("当前查看：" + _toDisplayString(currentUser.value.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table, {
                    "max-height": tableHeight+'px',
                    "summary-method": getSummaries,
                    "show-summary": "",
                    border: "",
                    data: _unref(detailData).salaryList
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "month",
                        label: "月度"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "basicAmount",
                        label: "基本薪酬",
                        formatter: _unref(formatNumber),
                        align: "right"
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        prop: "commission",
                        label: "提成",
                        formatter: _unref(formatNumber),
                        align: "right"
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        prop: "socialSecurity",
                        formatter: _unref(formatNumber),
                        label: "社保公积金（不包含个人支付部分）",
                        width: "260",
                        align: "right"
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        prop: "reward",
                        label: "奖金",
                        formatter: _unref(formatNumber),
                        align: "right"
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        prop: "monthlySalary",
                        formatter: _unref(formatNumber),
                        label: "当月薪酬",
                        align: "right"
                      }, null, 8, ["formatter"])
                    ]),
                    _: 1
                  }, 8, ["max-height", "data"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})